var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 14.3734 23.2962 16.6934 21.9776 18.6668C20.659 20.6402 18.7849 22.1783 16.5922 23.0865C14.3995 23.9948 11.9867 24.2324 9.6589 23.7694C7.33113 23.3064 5.19293 22.1635 3.5147 20.4853C1.83647 18.8071 0.693607 16.6689 0.230584 14.3411C-0.232439 12.0133 0.00519377 9.60052 0.913445 7.40781C1.8217 5.21509 3.35976 3.34095 5.33315 2.02237C7.30654 0.703792 9.62662 0 12 0C15.1826 0 18.2348 1.26427 20.4853 3.51471C22.7357 5.76515 24 8.8174 24 12Z",
    fill: "#3C5999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.02 12.48H12.85V20.27H9.56V12.48H8V9.73999H9.56V7.97C9.50505 7.16392 9.77218 6.36897 10.3028 5.75964C10.8333 5.15032 11.584 4.77641 12.39 4.72H15.37V7.38H13.6C13.5133 7.37459 13.4264 7.38633 13.3442 7.41458C13.2621 7.44284 13.1863 7.48705 13.1212 7.54465C13.0562 7.60225 13.0032 7.67213 12.9652 7.75027C12.9273 7.82841 12.9051 7.91327 12.9 8C12.8949 8.04319 12.8949 8.08682 12.9 8.13V9.73999H15.36L15.02 12.48Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fcee470ee957d6e9474bd74042ef4ff6.svg";
export { ForwardRef as ReactComponent };